import React from 'react';
import './SearchBar.css';
import { Search } from 'lucide-react';

function SearchBar({ onSearch }) {
  return (
    <div className="search-bar">
      <Search size={16} className="search-icon" />
      <input
        type="text"
        placeholder="Search metadata..."
        onChange={(e) => onSearch(e.target.value)}
      />
    </div>
  );
}

export default SearchBar;